import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { color } from '../../templates/Ui';
import { Link } from '@inertiajs/react';
const baseStyle = css `
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    background-color: #f6f6f6;
    padding: 10px 10px 10px 13px;
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    text-decoration: none;
    transition: all 50ms ease-in-out;

    &:before {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        width: 3px;
        height: 100%;
        background-color: ${props => props.theme.primary.base};
    }

    &:last-child {
        border-bottom-right-radius: 6px;
        border-bottom-left-radius: 6px;
    }

    @media only screen and (min-width: 992px) {
        border: none;
        margin: 0;
        border-radius: 0;
        padding: 18px 10px;

        &:before {
            display: none;
        }

        &:nth-child(even) {
            background-color: #f5f5f7;
        }

        &:nth-child(odd) {
            background-color: ${color.body.base};
        }

        ${props => !props.noHover &&
    css `
                &:hover {
                    background-color: #e9eaee;
                }
            `}

        ${props => props.background === 'white' &&
    css `
                background-color: ${color.body.base};

                &:nth-child(even) {
                    background-color: ${color.body.base};
                }
            `}
        }
}
`;
const StyledLinkTableRow = styled(Link) `
    ${baseStyle};

    &[disabled] {
        cursor: default;
        pointer-events: none;
        opacity: 0.7;
    }
`;
const StyledTableRow = styled.div `
    ${baseStyle};
`;
const TableRow = ({ href, disabled, background, ...restProps }) => (_jsx(_Fragment, { children: href ? (_jsx(StyledLinkTableRow, { disabled: disabled, href: href, as: restProps.download ? 'a' : undefined, ...restProps })) : (_jsx(StyledTableRow, { background: background, ...restProps })) }));
export default TableRow;
